export const AVAILABILITY_OPTIONS = [
  { value: '9AM' },
  { value: '10AM' },
  { value: '11AM' },
  { value: '12PM' },
  { value: '1PM' },
  { value: '2PM' },
  { value: '3PM' },
];
